'use client';

import { useEffect } from 'react';
import { useSearchParams } from 'next/navigation';
import { toast } from 'sonner';

type ToastMessages = {
  [key: string]: string;
};

const defaultMessages: ToastMessages = {
  contrasena_actualizada: 'Contraseña actualizada correctamente.',
};

export function useToastQueryMessage(customMessages?: ToastMessages) {
  const searchParams = useSearchParams();

  useEffect(() => {
    const mensaje = searchParams.get('mensaje');
    const allMessages = { ...defaultMessages, ...customMessages };

    if (mensaje && allMessages[mensaje]) {
      toast.success(allMessages[mensaje]);
    }
  }, [searchParams, customMessages]);
}
